export const EXPAND = "activation.common.expand";
export const COLLAPSE = "activation.common.collapse";
